import * as React from 'react'

import Layout from 'src/components/organisms/Layout'
import Hero from 'src/components/organisms/Hero'
import TimelineSection from 'src/components/organisms/TimelineSection'
import ContentSectionFullWidth from 'src/components/organisms/ContentSectionFullWidth'
import SEO from 'src/utils/seo'

import {diagMaze, leaders} from 'src/assets/images/backgrounds'

import type {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

interface Props {
  heroContent: () => ReactJSXElement
  journeyContent: () => ReactJSXElement
  leadershipContent: () => ReactJSXElement
}

const HomePage = ({
  heroContent: HeroContent,
  journeyContent: JourneyContent,
  leadershipContent,
}: Props) => {
  return (
    <Layout>
      <SEO title="NCFX | About us" />
      <Hero background={diagMaze} wide>
        <HeroContent />
      </Hero>
      <TimelineSection>
        <JourneyContent />
      </TimelineSection>
      <ContentSectionFullWidth
        gradientbk={leaders}
        content={leadershipContent}
      />
    </Layout>
  )
}

export default HomePage
